<template>
  <v-theme-provider :dark="dark">
    <div>
      <base-info-card title="KEEP IN TOUCH WITH US" pace="6"> </base-info-card>

      <base-business-contact dense />
    </div>
  </v-theme-provider>
</template>

<script>
export default {
  name: "BaseBusinessInfo",

  props: { dark: Boolean },

  data: () => ({
    business: [
      {
        icon: "mdi-map-marker-outline",
        title: "Address",
        text: "810 Geylang Rd, #03-145D City Plaza, Singapore 409286",
      },
      {
        color: "#000000",
        icon: "mdi-cellphone",
        title: "Phone",
        text: " 66107758 / 66107026 +65-89209748",
      },
      {
        color: "#000000",
        icon: "mdi-email",
        title: "Email",
        text: "contact@JoanRecruit.com <br> www.JoanRecruit.com",
      },
      {
        color: "#000000",
        icon: "mdi-clock",
        title: "Time",
        text: "Monday - Sunday 11am to 8pm (please make an appointment)",
      },
    ],
  }),
};
</script>
<style scoped>
i.v-icon.v-icon {
  color: red;
}
</style>
